import { useEffect, useState } from 'react';

const useTabInteractionCheck = () => {
  const [isTabInteraction, setIsTabInteraction] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Tab') setIsTabInteraction(true);
    };
    const handleMouseDown = () => setIsTabInteraction(false);
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('mousedown', handleMouseDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  return isTabInteraction;
};

export default useTabInteractionCheck;
